/**
 * @generated SignedSource<<3bf5c936ded74db07976e7a806175f69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AllShoppersModal_viewer$data = {
  readonly allShoppingWith: ReadonlyArray<{
    readonly groupName: string | null;
    readonly shoppers: ReadonlyArray<{
      readonly name: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null> | null;
  readonly " $fragmentType": "AllShoppersModal_viewer";
};
export type AllShoppersModal_viewer$key = {
  readonly " $data"?: AllShoppersModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"AllShoppersModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AllShoppersModal_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ShoppingWithGroup",
      "kind": "LinkedField",
      "name": "allShoppingWith",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "groupName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ShoppingWithShopper",
          "kind": "LinkedField",
          "name": "shoppers",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "60a9b2a273ddf3a11b7a7da5923481f7";

export default node;
